import { ProductName } from 'situview-webapi-client';

/**
 * situDAYDREAM's product. `ProductName.DayDreamFacade = 17` is mirrored by name across the
 * SituWarp, SituView, RenderService and SituAnalytics enums, so all four generated clients
 * must carry it before the portal compiles (TypeScript compares enums member by member).
 */
export const DAYDREAM_PRODUCT_NAME = ProductName.DayDreamFacade;

export function isDaydreamProduct(productName: ProductName | undefined): boolean {
  return productName === DAYDREAM_PRODUCT_NAME;
}

export const DAYDREAM_BRAND = 'situDAYDREAM';
